<template>
  <router-view />
</template>

<script>
export default {
  name: "Main",
  components: {
    
  },
  props: {
    
  },
  
};
</script>

<style>

</style>
